import AllActionTypes from '../Utility/AllActionTypes';
export const selectChooseBranch = (value) => async (dispatch) => {
    dispatch({
        type: AllActionTypes.SELECT_BRANCH_DATA,
        payload: value
    });
}

export const loaderStateTrue = () => async (dispatch) => {

    dispatch({
        type: AllActionTypes.LOADER_STATE_TRUE,
        payload: true
    });
}

export const loaderStateFalse = () => async (dispatch) => {

    dispatch({
        type: AllActionTypes.LOADER_STATE_FALSE,
        payload: false
    });
}


export const handleLeft = (value) => async (dispatch) => {
    dispatch({
        type: AllActionTypes.HANDLE_LEFT,
        payload: value
    });
};

export const handleActiveLink = (path, active_toggle) => async (dispatch) => {
    let data = {
        activeClass: path,
        accName: active_toggle
    };
    dispatch({
        type: AllActionTypes.ACTIVE_LINK,
        payload: data
    });
};

export const roleWisePermission = (value) => async (dispatch) => {
    dispatch({
        type: AllActionTypes.ROLE_PERMISSION,
        payload: value
    });
};

// Add a global debounce mechanism to prevent rapid-fire dispatches
let lastDispatchedData = null;

export const userSearchData = (value) => async (dispatch) => {
    // Create a signature to compare with last dispatched data
    const currentDataSignature = JSON.stringify({
        destination: value?.destination,
        start_date: value?.start_date?.toString(),
        end_date: value?.end_date?.toString(),
        adult: value?.adult,
        children: value?.children,
        children_age: value?.children_age,
        filterData: value?.filterData,
        selectedRoom: value?.selectedRoom
    });

    // Compare with previous dispatch to prevent duplicate/infinite dispatches
    if (currentDataSignature === lastDispatchedData) {
        // console.log('Skipping duplicate userSearchData dispatch');
        return;
    }

    lastDispatchedData = currentDataSignature;

    dispatch({
        type: AllActionTypes.USER_SEARCH_DATA,
        payload: value
    });
};
export const groupTourPackageSearchData = (value) => async (dispatch) => {
    dispatch({
        type: AllActionTypes.GROUP_TOUR_PACKAGE_SEARCH_DATA,
        payload: value
    });
};

export const userSearchDataError = (value) => async (dispatch) => {
    dispatch({
        type: AllActionTypes.USER_SEARCH_DATA_ERROR,
        payload: value
    });
};


export const connectToWebsocket = (email, id) => async (dispatch, getState, api) => {

    if ("WebSocket" in window) {
        //dev
        var ws = await new WebSocket(`wss://860lo4o5jd.execute-api.eu-west-1.amazonaws.com/dev`);
    } else {
        alert("WebSocket NOT supported by your Browser!");
    }
    dispatch({
        type: AllActionTypes.CONNECT_DISCONNECT_TO_WEBSOCKET,
        payload: ws
    });
};
export const disconnectToWebsocket = (ws) => async (dispatch, getState, api) => {
    await ws.close();
    dispatch({
        type: AllActionTypes.CONNECT_DISCONNECT_TO_WEBSOCKET,
        payload: {}
    });
};
export const lockprocess = (value) => async (dispatch) => {
    dispatch({
        type: AllActionTypes.LOCK_FLAG,
        payload: value
    });
};
export const planningEditable = (value) => async (dispatch) => {
    dispatch({
        type: AllActionTypes.PLANNING_EDITABLE_BEFORE_CURRENT_DAY,
        payload: value
    });
};

export const priceDistributionRequestData = (value) => async (dispatch) => {
    dispatch({
        type: AllActionTypes.PRICE_DISTRIBUTION_REQUEST_DATA,
        payload: value
    });
};
export const priceDistributionResponseData = (value) => async (dispatch) => {
    dispatch({
        type: AllActionTypes.PRICE_DISTRIBUTION_RESPONSE_DATA,
        payload: value
    });
};

export const trendingDestination = (value) => async (dispatch) => {
    dispatch({
        type: AllActionTypes.TRENDING_DESTINATION,
        payload: value
    });
};

export const tourSearchData = (value) => async (dispatch) => {
    dispatch({
        type: AllActionTypes.TOUR_SEARCH_DATA,
        payload: value
    });
};
export const hotelGroupPackageSelectedData = (value) => async (dispatch) => {
    dispatch({
        type: AllActionTypes.HOTEL_GROUP_PACKAGE_SELECTED_DATA,
        payload: value
    });
};
export const setGlobalSeoData = (value) => async (dispatch) => {
    dispatch({
        type: AllActionTypes.GLOBAL_SEO_DATA,
        payload: value
    });
};